import useHasCompletedPaymentsApplication from '../behaviors/commercePayment/hooks/useHasCompletedPaymentsApplication';
import { getCommerceHomeUrl } from 'growth-payments-core/urls/urls';
export const useCommerceHomeUrl = () => {
  const {
    completedApplication
  } = useHasCompletedPaymentsApplication();
  return completedApplication ? getCommerceHomeUrl() : undefined;
};